module.exports = __webpack_public_path__ + "img/properti.7fa9bde6.jpg";